import type { GridSortModel } from '@mui/x-data-grid-premium';

export type CusipsSortItem = {
  Property: string;
  Direction: string;
  Order: number;
};

export type CusipsListRequest = {
  SearchTerm?: string;
  Sort?: CusipsSortItem[];
  Page?: number;
  Limit?: number;
};

/** Flat query params for Firm Cusips list / CusipsExport (CustomModelBinder). */
export type CusipsQueryParams = Record<string, string | number | boolean>;

export const DEFAULT_CUSIPS_SORT_MODEL: GridSortModel = [
  { field: 'Value', sort: 'desc' },
];

export function sortModelToCusipsApiSort(
  sortModel: GridSortModel,
): CusipsSortItem[] {
  if (sortModel.length === 0) {
    return [{ Property: 'Value', Direction: 'desc', Order: 1 }];
  }
  return sortModel.map((item, index) => ({
    Property: item.field,
    Direction: item.sort === 'asc' ? 'asc' : 'desc',
    Order: index + 1,
  }));
}

/**
 * Expands nested Sort into bracketed keys the firm CustomModelBinder expects
 * (e.g. sort[0].Property).
 */
export function buildCusipsQueryParams(
  args: CusipsListRequest,
): CusipsQueryParams {
  const params: CusipsQueryParams = {};

  if (args.SearchTerm !== undefined) {
    params.SearchTerm = args.SearchTerm;
  }
  if (args.Page !== undefined) {
    params.Page = args.Page;
  }
  if (args.Limit !== undefined) {
    params.Limit = args.Limit;
  }

  args.Sort?.forEach((sortItem, index) => {
    params[`sort[${String(index)}].Property`] = sortItem.Property;
    params[`sort[${String(index)}].Direction`] = sortItem.Direction;
    params[`sort[${String(index)}].Order`] = sortItem.Order;
  });

  return params;
}
